import PropTypes from 'prop-types';

export default PropTypes.shape({
  key: PropTypes.string,
  name: PropTypes.string,
  active: PropTypes.bool,
});
